
import RcDomainMap from "../../../../common/RcDomainMap.js";
import CheckListItemOption from "./CheckListItemOption.js";
import CheckListItemUtils from "./CheckListItemOptionUtils.js";

export default class CheckListItemOptionMap extends RcDomainMap {
  
  static MODEL_NAME = "CheckListItemOptionMap";

  constructor(domain, data) {
    super(domain, data, CheckListItemOptionMap.MODEL_NAME);
  }
  
  find() {
    var keys = this.keys();
    var found = new CheckListItemOptionMap(this.domain, {} );
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var option = this.getCheckListItemOption(key);
      if (option.isNew()) {
        found.add(option);
      } else {
        var data = this.domain.checklists().items().options().findById(key);
        option = new CheckListItemOption(this.domain, data);
        if (!option.isNew()) {
          found.add(option);
        }
      }
    }
    
    return found;
  }
  
  populate() {
    var found = this.find();
    this.addAll(found);
    return this;
  }
  
  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getCheckListItemOption(key);
      values.push(item);
    }
    return values;
  }
  
  sortByName() {
    var list = this.list();
    var fnctn = CheckListItemUtils.SortByName;
    var sorted = list.sort(fnctn);
    return sorted;
  }
  
  sortByIndex() {
    var list = this.list();
    var fnctn = CheckListItemUtils.SortByIndex;
    var sorted = list.sort(fnctn);
    return sorted;
  }
  
  first() {
    var all = this.list();
    if (all.length > 0) {
      return all[0];
    }
    return new CheckListItemOption(this.domain);
  }
  
  addChecklistItemOption(itemOption) {
    super.add(itemOption);
    return this;
  }

  getChecklistItemOption(key) {
    return this.getCheckListItemOption(key);
  }
  
  getCheckListItemOption(key) {
    var value = super.get(key);
    return new CheckListItemOption(this.domain, value);
  }
  
  copy() {
    var data = this._copy();
    return new CheckListItemOptionMap(this.domain, data);
  }
  
  minors() {
    let map = new CheckListItemOptionMap(this.domain, {});
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getCheckListItemOption(key);
      if (item.isCategoryMinor()) {
        map.add(item);
      }
    }
    return map;
  }

  majors() {
    let map = new CheckListItemOptionMap(this.domain, {});
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getCheckListItemOption(key);
      if (item.isCategoryMajor()) {
        map.add(item);
      }
    }
    return map;
  }

  goods() {
    let map = new CheckListItemOptionMap(this.domain, {});
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getCheckListItemOption(key);
      if (item.isCategoryGood()) {
        map.add(item);
      }
    }
    return map;
  }
}